module.exports = __webpack_public_path__ + "static/bonfiscal-mobile-193ae940bd100f4cf06ab1810364f0b5.jpg";